import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {map} from 'lodash';
import {Card, Button, Menu, Segment} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {noTimeZoneLongISODate} from '../../../../common/constants/datesFormat';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import {updateFormData, processFiles, validateErrors, bulletinSectionTypes} from '../../../utils';
import BulletinDownloadRecord from './tabs/downloadRecord';
import BulletinForm from './tabs/form';
import BulletinAttachments from './tabs/attachments';
import BulletinParts from './tabs/parts';
import './styles.scss';

class BulletinTMC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeItem': 'generalInfo',
      'bulletinId': '',
      'type': 'TMC',
      'model': '',
      'katashiki': '',
      'subject': '',
      'createdDate': moment(),
      'parts': [],
      'edit': true,
      'sectionTypes': {},
    };
  }

  componentDidMount() {
    const {id, isUserFromTDE} = this.props;
    if (
      isUserFromTDE &&
      (!hasAccessPermission(
        this.props.permissions,
        resources.BulletinTMC,
        scopes.Create
      ) &&
      !hasAccessPermission(
        this.props.permissions,
        resources.BulletinTMC,
        scopes.Edit
      ))
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    if (!isUserFromTDE) {
      this.setState({'edit': false});
    }
    this.props.clearBulletinForm();
    if (id) {
      this.props.fetchBulletinById(id);
      if (isUserFromTDE) {
        this.props.fetchDowloadRecord(id);
      }
    } else {
      this.props.fetchBulletinIdByVehSystem('TMC');
    }
    this.setState({'sectionTypes': bulletinSectionTypes(id, isUserFromTDE)});
  }

  componentDidUpdate() {
    const {bulletinId, type} = this.state;
    const {bulletin, id, bulletinCreated, savedRecord} = this.props;

    if (id && bulletin && bulletin.bulletinId !== bulletinId) {
      const {bulletinId, generalInfo, type, parts, createdDate} = bulletin;
      const formatDate = moment(createdDate, noTimeZoneLongISODate);
      this.setState({...this.state, bulletinId, type, 'createdDate': formatDate, parts, ...generalInfo});
    } else if (type && bulletin && bulletinId !== bulletin.bulletinId) {
      this.setState({'bulletinId': bulletin.bulletinId});
    } else if (bulletinCreated) {
      this.props.clearBulletinForm();
      this.props.navigateTo(`/boletines/TMC/editar/${bulletinId}`);
    } else if (savedRecord) {
      const {username, date} = savedRecord;
      const baseUrl = process.env.REP_FORM_URL;
      const fileUrl = `${baseUrl}/bulletin/report/${bulletinId}?&username=${username}&date=${date}`;
      downloadFile(fileUrl);
      this.props.clearBulletinForm();
    }
  }

  componentWillUnmount() {
    this.props.clearBulletinForm();
    this.props.clearVehicleQuery();
  }

  onUpdateForm = (e, {name, value}) => {
    const finalValue = (name === 'model' || name === 'katashiki') ? value.toUpperCase() : value;
    this.setState({[name]: finalValue});
    if (name === 'type') {
      this.props.fetchBulletinIdByVehSystem(value);
    }
  };

  onSubmit = () => {
    const {error, message} = validateErrors(this.state);
    if (error) {
      this.props.addMessageBoxError(message);
    } else {
      const {id, attachments} = this.props;
      const formData = processFiles(attachments);
      const finalForm = updateFormData(this.state, formData);
      const updated = !!id;
      if (id) {
        this.props.updateBulletinById(id, finalForm);
      } else {
        this.props.addNewBulletin(finalForm);
      }
      this.props.sendBulletinMail({...this.state, updated});
    }
  };

  onDownload = async() => {
    const {user, dealerId, dealerAgency} = this.props;
    const {bulletinId} = this.state;
    await this.props.saveDowloadRecord({bulletinId, user, dealerId, dealerAgency});
  };

  handleItemClick = (idx) => {
    this.setState({'activeItem': idx});
  };

  renderContent = () => {
    const {activeItem, parts, edit} = this.state;
    const {id} = this.props;

    if (activeItem === 'generalInfo') {
      return (
        <BulletinForm
          {...this.state}
          id={id}
          onUpdateForm={this.onUpdateForm}
        />
      );
    } else if (activeItem === 'attachments') {
      return (
        <BulletinAttachments {...this.state} onUpdateForm={this.onUpdateForm} />
      );
    } else if (activeItem === 'parts') {
      return (
        <BulletinParts
          parts={parts}
          edit={edit}
          onUpdateForm={this.onUpdateForm}
        />
      );
    }
    return <BulletinDownloadRecord bulletinId={id} />;
  };

  render() {
    const {loading, id, isUserFromTDE, loadingRecord} = this.props;
    const {activeItem, sectionTypes, edit} = this.state;

    return (
      <div className='bulletin-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Boletines TMC</h2>
              <div className='title-bar-actions'>
                {edit && (
                  <Button primary disabled={loading} loading={loadingRecord} onClick={this.onSubmit}>
                    Guardar
                  </Button>
                )}
                {id && !isUserFromTDE && (
                  <Button color='black' disabled={loading} onClick={this.onDownload}>
                    Generar Reporte
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className='bulltein-form-container'>
          <Menu attached='top' color='red' tabular>
            {map(sectionTypes, (type, idx) => (
              <Menu.Item
                key={idx}
                name={type}
                color='red'
                active={activeItem === idx}
                onClick={() => this.handleItemClick(idx)}
              />
            ))}
          </Menu>
          <Segment attached='bottom'>{this.renderContent()}</Segment>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'id': ownProps.params && ownProps.params.id,
    'numTwcDealer': ownProps.params && ownProps.params.numTwcDealer,
    'dealerUpdateId': ownProps.params && ownProps.params.dealerId,
    'bulletinCreated': state.bulletin.bulletinCreated,
    'permissions': state.session.permissions,
    'part': state.warrantiesCategories.part,
    'bulletin': state.bulletin.bulletin,
    'attachments': state.bulletin.attachments,
    'isUserFromTDE': state.session.isUserFromTDE,
    'fileURL': state.bulletin.fileURL,
    'dealerId': state.session.dealerId,
    'dealerAgency': state.session.dealerAgency,
    'savedRecord': state.bulletin.savedRecord,
    'loadingRecord': state.bulletin.loadingRecord,
    'user': state.session.user,
  };
};

const {
  fetchBulletinIdByVehSystem,
  fetchDowloadRecord,
  updateBulletinById,
  addMessageBoxError,
  fetchBulletinById,
  clearVehicleQuery,
  clearBulletinForm,
  saveDowloadRecord,
  sendBulletinMail,
  addNewBulletin,
  navigateTo,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchBulletinIdByVehSystem,
    fetchDowloadRecord,
    updateBulletinById,
    addMessageBoxError,
    clearVehicleQuery,
    fetchBulletinById,
    clearBulletinForm,
    saveDowloadRecord,
    sendBulletinMail,
    addNewBulletin,
    navigateTo,
  })(BulletinTMC)
);
